import { useCallback } from 'react';
import useCompanySetting from './useCompanySetting';

const useFormatCurrency = () => {
    const {
        companySetting: { currency },
    } = useCompanySetting();

    return useCallback((amount: number) => `${currency}${amount.toLocaleString()}`, [currency]);
};

export default useFormatCurrency;
